import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { empty, or } from '@ember/object/computed';
import Controller from '@ember/controller';
import pluralize from 'cio/utils/pluralize';
import { task } from 'ember-concurrency';

export default class DevicesController extends Controller {
  @service api;
  @service apiErrors;
  @service auth;
  @service alerts;
  @service environment;

  @computed('environment.enabledActions')
  get isPushEnabled() {
    return this.get('environment.enabledActions').includes('push');
  }

  selectedDevices = null;

  @empty('model.devices') noDevicesAvailable;

  @empty('selectedDevices') noDevicesSelected;

  @or('noDevicesSelected', 'isSaving') deleteDisabled;

  get canEdit() {
    return this.auth.hasPermission('journeys/people/edit');
  }

  @computed('model.devices.length', 'selectedDevices.length')
  get deviceCount() {
    let total = this.get('model.devices.length');
    let count = this.get('selectedDevices.length');
    let label = pluralize(total, 'device');

    return `${count} selected out of ${total} ${label}`;
  }

  @computed('selectedDevices.length')
  get selectionBasedLabel() {
    let count = this.get('selectedDevices.length');
    return pluralize(count, 'device');
  }

  @computed('model.devices.length', 'selectedDevices.length')
  get allDevicesSelected() {
    return this.get('model.devices.length') === this.get('selectedDevices.length');
  }

  prepareDevices() {
    this.set('selectedDevices', []);
  }

  save = task(async (devices) => {
    let modelId = this.get('model.id');
    await this.get('api').delete(`customers/${modelId}/devices`, {
      data: { devices },
    });

    let count = devices.length;
    let noun = pluralize(count, 'device');
    let deviceCount = `${count} selected ${noun}`;

    this.get('alerts').success('devices.delete', `${deviceCount} will be deleted soon`);
  });

  @action
  onSave() {
    return this.get('save').perform(this.get('selectedDevices'));
  }

  @action
  checkAllDevices(checked) {
    if (checked) {
      this.set(
        'selectedDevices',
        this.model.devices.content.map((device) => device.id),
      );
    } else {
      this.set('selectedDevices', []);
    }
  }

  @action
  checkDevice(id, checked) {
    let { selectedDevices } = this;

    if (checked) {
      selectedDevices.addObject(id);
    } else {
      selectedDevices.removeObject(id);
    }
  }
}
